<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     email: '',
     username: '',
     password: '',
     smtp_host: '',
     smtp_port: '',
     smtp_encryption: '',
     imap_host: '',
     imap_port: '',
     imap_encryption: '',
     mail_provider: '',
     platform: '',
     api_key: '',
     api_secret: '',
     user_id: '',
     profile_id: '',
     client_id: '',
     client_secret: '',
     auth_token: '',
     sender_id_sms: '',
     sender_id_whatsapp: '',
     business_account_id: '',
     username: '',
     secret: '',
     showPassword: false
    };
  },
  methods: {
   
 //MAILER START   
   mailer(provider){
    this.resetMailerForm();
    this.mail_provider = provider; 
    this.fetchMailer();
   },

   async fetchMailer(){
    this.errors = {};
    this.setLoading(true);
    try{
     const response = await axios.get(`/mail-configurations/provider/${this.mail_provider}`);
     const data = response.data.data;
     if(data){
      this.id = data.id;
      this.email = data.email;
      this.username = data.username;
      this.password = data.decrypted_password;
      this.smtp_host = data.smtp_host;
      this.smtp_port = data.smtp_port;
      this.smtp_encryption = data.smtp_encryption;
      this.imap_host = data.imap_host;
      this.imap_port = data.imap_port;
      this.imap_encryption = data.imap_encryption;
     }
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);   
    }
   },

   async mailConfiguration(){
    this.errors = {};
    this.setLoading(true); 

    try{
     const payload = {
      id: this.id,  
      email: this.email,
      username: this.username,
      password: this.password,
      smtp_host: this.smtp_host,
      smtp_port: this.smtp_port,
      smtp_encryption: this.smtp_encryption,
      imap_host: this.imap_host,
      imap_port: this.imap_port,
      imap_encryption: this.imap_encryption,
      provider: this.mail_provider,
     };

     let response = [];
     if(this.id){
      response = await axios.put(`/mail-configurations/${this.id}/update`, payload);
     }else{
      response = await axios.post(`/mail-configurations/create`, payload);  
     }

     this.$swalToast(response.data.message); 
     this.$emit('updated');
     this.$closeModal('app_store_mailer');
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async disconnectMailer(id){
   const result = await this.$confirm({});
   if(result.isConfirmed){ 
    this.setLoading(true);
    try{
     const response = await axios.delete(`/mail-configurations/${id}/delete`);
     this.$swalToast("Disconnected successfully.");
     this.$emit('updated');
     this.$closeModal('app_store_mailer');
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }  
  }, 

  resetMailerForm(){
   this.id = '';
   this.email = '';
   this.username = '';
   this.password = '';
   this.smtp_host = '';
   this.smtp_port = '';
   this.smtp_encryption = '';
   this.imap_host = '';
   this.imap_port = '';
   this.imap_encryption = '';
  },

//MAILER END  

  toggleShow() {
   this.showPassword = !this.showPassword;
  },

// ########################################################## //
//     **********  LEAD IMPORT CONFIG START  ***********
// ########################################################## //

  importConfig(platform){
   this.resetImportConfigForm(); 
   this.platform = platform;
   this.leadImportConfig();
  },

  async leadImportConfig(){
   this.errors = {};
   this.setLoading(true);
    try{
     const response = await axios.get(`/lead-import-configs/platform/${this.platform}`);
     const data = response.data.data;
     if(data){
      this.id = data.id;
      this.api_key = data.api_key;
      this.email = data.email;
      this.user_id = data.user_id;
      this.profile_id = data.profile_id;
     }
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);   
    } 
  },

  async leadImportConfiguration(){
   this.errors = {};
    this.setLoading(true); 

    try{
     const payload = {
      id: this.id,  
      email: this.email,
      api_key: this.api_key,
      user_id: this.user_id,
      platform: this.platform,
      profile_id: this.profile_id
     };

     let response = [];
     if(this.id){
      response = await axios.put(`/lead-import-configs/${this.id}/update`, payload);
     }else{
      response = await axios.post(`/lead-import-configs/create`, payload);  
     }

     this.$swalToast(response.data.message); 
     this.$emit('updated');
     this.$closeModal('app_store_import_config');
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    } 
  },
  
  async disconnectImportConfig(id){
   const result = await this.$confirm({});
   if(result.isConfirmed){ 
    this.setLoading(true);
    try{
     const response = await axios.delete(`/lead-import-configs/${id}/delete`);
     this.$swalToast("Disconnected successfully.");
     this.$emit('updated');
     this.$closeModal('app_store_import_config');
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }  
  },

  resetImportConfigForm(){
   this.id = ''; 
   this.email = '';
   this.api_key = '';
   this.user_id = '';
   this.profile_id = '';
  },

// ########################################################## //
//    **********  LEAD IMPORT CONFIG END  ***********
// ########################################################## //

// ########################################################## //
//    *********  PAYMENT GATEWAY CONFIG START  ***********
// ########################################################## //

  async paymentGatewayConfig(platform){
   this.resetPaymentGatewayConfigForm(); 
   this.platform = platform;
   this.fetchPaymentGatewayConfig();
  },

  async fetchPaymentGatewayConfig(){
   this.errors = {};
   this.setLoading(true);
    try{
     const response = await axios.get(`/payment-gateways/platform/${this.platform}`);
     const data = response.data.data;
     if(data){
      this.id         = data.id;
      this.api_key    = data.api_key;
      this.api_secret = data.api_secret;
     }
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);   
    } 
  },

  async paymentGatewayConfiguration(){
   this.errors = {};
   this.setLoading(true); 
    try{
     const payload = {
      id: this.id,  
      api_key: this.api_key,
      api_secret: this.api_secret,
      platform: this.platform,
     };

     let response = [];
     if(this.id){
      response = await axios.put(`/payment-gateways/${this.id}/update`, payload);
     }else{
      response = await axios.post(`/payment-gateways/create`, payload);  
     }

     this.$swalToast(response.data.message); 
     this.$emit('updated');
     this.$closeModal('app_store_payment_gateway_config');
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    } 
  },
  
  async disconnectPaymentGatewayConfig(id){
   const result = await this.$confirm({});
   if(result.isConfirmed){ 
    this.setLoading(true);
    try{
     const response = await axios.delete(`/payment-gateways/${id}/delete`);
     this.$swalToast("Disconnected successfully.");
     this.$emit('updated');
     this.$closeModal('app_store_payment_gateway_config');
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }  
  },

  resetPaymentGatewayConfigForm(){
   this.id = ''; 
   this.api_key = '';
   this.api_secret = ''; 
  },

// ########################################################## //
//    *********  PAYMENT GATEWAY CONFIG END  ***********
// ########################################################## //  

// ########################################################## //
//     **********   ACCOUNTING CONFIG START ***********
// ########################################################## //

  accountingConfig(platform){
   this.resetAccountingConfigForm(); 
   this.platform = platform;
   this.getAccountingConfig();
  },

  async getAccountingConfig(){
   this.errors = {};
   this.setLoading(true);
    try{
     const response = await axios.get(`/accounting-configs/platform/${this.platform}`);
     const data = response.data.data;
     if(data){
      this.id              = data.id;
      this.client_id       = data.client_id;
      this.client_secret   = data.client_secret;
     }
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);   
    } 
  },

  async accountingConfiguration(){
   this.errors = {};
   this.setLoading(true); 
   
    if(this.platform === 'zoho_books'){
     if(!this.client_id) {
      this.errors.client_id = ['Client ID is required for Zoho Books'];
      this.setLoading(false);
      return;
     }
     if(!this.client_secret) {
      this.errors.client_secret = ['Client Secret is required for Zoho Books'];
      this.setLoading(false);
      return;
     }  

    const adminUuid = this.auth?.uuid;
    
    if(!adminUuid) {
     this.$swalToast('Admin UUID not found. Please refresh.', 'error');
     this.setLoading(false);
     return;
    }
    
     // Open Zoho OAuth tab (Backend handles everything)
     const authUrl = `${process.env.VUE_APP_API_BASE_URL}/accounting/zoho_books/auth/${adminUuid}?client_id=${encodeURIComponent(this.client_id)}&client_secret=${encodeURIComponent(this.client_secret)}`;
    
     window.open(authUrl, '_blank', 'width=600,height=700');
     this.$swalToast('Please authorize Zoho in new tab. Refresh this page after approval.');
     this.setLoading(false);
     return; 

    }

    try{
     const payload = {
      id: this.id,  
      platform: this.platform,
      client_id: this.client_id,
      client_secret: this.client_secret,
     };
     
     const response = await axios.post(`/accounting-configs/create`, payload);  

     this.$swalToast(response.data.message); 
     this.$emit('updated');
     this.$closeModal('app_store_accounting_config');
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    } 
  },
  
  async disconnectAccountingConfig(id){
   const result = await this.$confirm({});
   if(result.isConfirmed){ 
    this.setLoading(true);
    try{
     const response = await axios.delete(`/accounting-configs/${id}/delete`);
     this.$swalToast("Disconnected successfully.");
     this.$emit('updated');
     this.$closeModal('app_store_accounting_config');
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }  
  },

  resetAccountingConfigForm(){
   this.id = ''; 
   this.client_id = '';
   this.client_secret = '';
  },

// ########################################################## //
//    **********  ACCOUNTING CONFIG END  ***********
// ########################################################## //

// ########################################################## //
//     *********** COMMUNICATION CONFIG START ***********
// ########################################################## //

  communicationConfig(provider){
   this.resetCommunicationConfigForm(); 
   this.provider = provider;
   this.getCommunicationConfig();
  },

  async getCommunicationConfig(){
   this.errors = {};
   this.setLoading(true);
    try{
     const response = await axios.get(`/communication-configs/provider/${this.provider}`);
     const data = response.data.data;
     if(data){
      this.id                 = data.id;
      this.api_key            = data.api_key_decrypted;
      this.auth_token         = data.auth_token_decrypted;
      this.sender_id_sms      = data.sender_id_sms;
      this.sender_id_whatsapp = data.sender_id_whatsapp;
      this.business_account_id = data.business_account_id;
      this.username            = data.username;
      this.secret              = data.secret;
     }
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);   
    } 
  },

  async communicationConfiguration(){
   this.errors = {};
   this.setLoading(true); 
    try{
     const payload = {
      id: this.id,  
      api_key: this.api_key,
      provider: this.provider,
      auth_token: this.auth_token,
      sender_id_sms: this.sender_id_sms,
      sender_id_whatsapp: this.sender_id_whatsapp,
      business_account_id: this.business_account_id,
      username: this.username,
      secret: this.secret,
     };
     
     const response = await axios.post(`/communication-configs/create`, payload);  

     this.$swalToast(response.data.message); 
     this.$emit('updated');
     this.$closeModal('app_store_communication_config');
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    } 
  },
  
  async disconnectCommunicationConfig(id){
   const result = await this.$confirm({});
   if(result.isConfirmed){ 
    this.setLoading(true);
    try{
     const response = await axios.delete(`/communication-configs/${id}/delete`);
     this.$swalToast("Disconnected successfully.");
     this.$emit('updated');
     this.$closeModal('app_store_communication_config');
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   }  
  },

  resetCommunicationConfigForm(){
   this.id = ''; 
   this.api_key = '';
   this.auth_token = '';
   this.sender_id_sms = '';
   this.sender_id_whatsapp = '';
   this.business_account_id = '';
   this.username = '';
   this.secret = '';
  },

// ########################################################## //
//    **********  COMMUNICATION CONFIG END  ***********
// ########################################################## //


 },
};
</script>

<template>

<!-- MAILER -->
 <div class="modal fade" id="app_store_mailer">
 <div class="modal-dialog modal-dialog-centered modal-mg w-100">
 <div class="modal-content">
 <div class="modal-header">
 <h4 class="modal-title">Connect <span class="text-capitalize">{{ mail_provider }}</span></h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
 </button>
 </div>
 <form @submit.prevent="mailConfiguration">
 <div class="modal-body pb-0">
  <div class="row">
 
    <div class="col-md-6">
    <div class="mb-3">
      <label class="form-label">Email</label>
      <input type="text" class="form-control" v-model="email" />
      <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
    </div>
    </div>

    <div class="col-md-6">
    <div class="mb-3">
      <label class="form-label"><i class="ti ti-info-circle me-2" title="Fill only if your email client use username for SMTP login"></i>Username </label>
      <input type="text" class="form-control" v-model="username" />
      <div v-if="errors.username" class="text-danger small mt-1">{{ errors.username[0] }}</div>
    </div>
    </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Password</label>
      <div class="pass-group">
       <input :type="showPassword ? 'text' : 'password'" v-model="password" class="pass-input form-control"/>
       <span @click="toggleShow" class="ti toggle-password"
        :class="{
         'ti-eye': showPassword,
         'ti-eye-off': !showPassword,
         }"></span>
        </div>
      <div v-if="errors.password" class="text-danger small mt-1">{{ errors.password[0] }}</div>
    </div>
    </div> 

    <div class="col-md-5">
    <div class="mb-3">
      <label class="form-label">SMTP Host</label>
      <input type="text" class="form-control" v-model="smtp_host" />
      <div v-if="errors.smtp_host" class="text-danger small mt-1">{{ errors.smtp_host[0] }}</div>
    </div>
    </div> 

    <div class="col-md-3">
    <div class="mb-3">
      <label class="form-label">SMTP Port</label>
      <input type="text" class="form-control" v-model="smtp_port" />
      <div v-if="errors.smtp_port" class="text-danger small mt-1">{{ errors.smtp_port[0] }}</div>
    </div>
    </div>
    
    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">SMTP Security</label>
     
       <div class="form-check form-check-inline form-checkbox-success mb-2">
        <input type="radio" class="form-check-input me-2" name="smtp_encryption" id="smtp_ssl" value="ssl" v-model="smtp_encryption">
        <label class="form-check-label" for="smtp_ssl">SSL</label>
       </div>

       <div class="form-check form-check-inline form-checkbox-success mb-2">
        <input type="radio" class="form-check-input me-2" name="smtp_encryption" id="smtp_tls" value="tls" v-model="smtp_encryption">
        <label class="form-check-label" for="smtp_tls">TLS</label>  
       </div>
      <div v-if="errors.smtp_encryption" class="text-danger small mt-1">{{ errors.smtp_encryption[0] }}</div>
    </div>
    </div>

    <div class="col-md-5">
    <div class="mb-3">
      <label class="form-label">IMAP Host</label>
      <input type="text" class="form-control" v-model="imap_host" />
      <div v-if="errors.imap_host" class="text-danger small mt-1">{{ errors.imap_host[0] }}</div>
    </div>
    </div> 

    <div class="col-md-3">
    <div class="mb-3">
      <label class="form-label">IMAP Port</label>
      <input type="text" class="form-control" v-model="imap_port" />
      <div v-if="errors.imap_port" class="text-danger small mt-1">{{ errors.imap_port[0] }}</div>
    </div>
    </div>
    
    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">IMAP Security</label>
     
       <div class="form-check form-check-inline form-checkbox-success mb-2">
        <input type="radio" class="form-check-input me-2" name="imap_encryption" id="imap_ssl" value="ssl" v-model="imap_encryption">
        <label class="form-check-label" for="imap_ssl">SSL</label>
       </div>

       <div class="form-check form-check-inline form-checkbox-success mb-2">
        <input type="radio" class="form-check-input me-2" name="imap_encryption" id="imap_tls" value="tls" v-model="imap_encryption">
        <label class="form-check-label" for="imap_tls">TLS</label>  
       </div>
      <div v-if="errors.imap_encryption" class="text-danger small mt-1">{{ errors.imap_encryption[0] }}</div>
    </div>
    </div>
    
 </div>
 </div>
 <div class="modal-footer">
  <button type="button" class="btn btn-danger btn-sm me-3" v-if="id" @click="disconnectMailer(id)"><i class="ti ti-alert-triangle me-2"></i> Disconnect</button>  
  <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
  <button type="submit" class="btn btn-primary">Save</button>
 </div>
</form>
</div>
</div>
</div>
<!-- MAILER -->

<!-- LEAD IMPORT CONFIG -->
 <div class="modal fade" id="app_store_import_config">
 <div class="modal-dialog modal-dialog-centered modal-sm w-100">
 <div class="modal-content">
 <div class="modal-header">
 <h4 class="modal-title">Connect <span class="text-capitalize">{{ platform }}</span></h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
 </button>
 </div>
 <form @submit.prevent="leadImportConfiguration">
 <div class="modal-body pb-0">
  <div class="row">

   <div class="warning-alert mb-2" v-if="platform === 'IndiaMART'">
   <strong>⚠️ Important:</strong> Please configure this URL 
   <span class="url-box">https://algoads.app/api/leads/webhook/IndiaMART/{{ auth?.uuid }}</span> in your <span class="text-capitalize">{{ platform }}</span> account for webhook.
   <a href="javascript:void(0);" class="btn btn-sm btn-outline-info" @click="$copyText(`https://algoads.app/api/leads/webhook/IndiaMART/${auth?.uuid}`)">Copy URL <i class="ti ti-copy"></i></a>
  <br>
  <a href="https://help.indiamart.com/knowledge-base/integration-of-indiamarts-lead-manager-crm-push-api-with-third-party-crms-real-time-push-of-leads/" target="_blank" style="color: #0d6efd; text-decoration: underline;"> Click here to see how to do it →</a>
  </div>

  <div class="warning-alert mb-2" v-if="platform === 'TradeIndia'">
   <!-- <strong>⚠️ Important:</strong>  -->
  <a href="" target="_blank" style="color: #0d6efd; text-decoration: underline;"> Click here to see how to do it →</a>
  </div> 
  
  <div class="warning-alert mb-2" v-if="platform === 'ExportersIndia'">
   <strong>⚠️ Important:</strong> Please configure this URL 
   <span class="url-box">https://algoads.app/api/leads/webhook/ExportersIndia/{{ auth?.uuid }}</span> in your <span class="text-capitalize">{{ platform }}</span> account for webhook.
   <a href="javascript:void(0);" class="btn btn-sm btn-outline-info" @click="$copyText(`https://algoads.app/api/leads/webhook/ExportersIndia/${auth?.uuid}`)">Copy URL <i class="ti ti-copy"></i></a>
  </div>

  <div class="warning-alert mb-2" v-if="platform === 'Justdial'">
   <strong>⚠️ Important:</strong> Please configure this URL 
   <span class="url-box">https://algoads.app/api/leads/webhook/Justdial/{{ auth?.uuid }}</span> in your <span class="text-capitalize">{{ platform }}</span> account for webhook.
   <a href="javascript:void(0);" class="btn btn-sm btn-outline-info" @click="$copyText(`https://algoads.app/api/leads/webhook/Justdial/${auth?.uuid}`)">Copy URL <i class="ti ti-copy"></i></a>
  </div>

   <div v-if="platform === 'TradeIndia'"> 
    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">User ID </label>
      <input type="text" class="form-control" v-model="user_id" required />
      <div v-if="errors.user_id" class="text-danger small mt-1">{{ errors.user_id[0] }}</div>
    </div>
    </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Profile ID </label>
      <input type="text" class="form-control" v-model="profile_id" required/>
      <div v-if="errors.profile_id" class="text-danger small mt-1">{{ errors.profile_id[0] }}</div>
    </div>
    </div>
   </div> 
 
    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Api Key</label>
      <input type="text" class="form-control" v-model="api_key" />
      <div v-if="errors.api_key" class="text-danger small mt-1">{{ errors.api_key[0] }}</div>
    </div>
    </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label"><i class="ti ti-info-circle me-2" title="Some platforms required email also for integration."></i>Email </label>
      <input type="text" class="form-control" v-model="email" />
      <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
    </div>
    </div>
    
 </div>
 </div>
 <div class="modal-footer">
  <button type="button" class="btn btn-danger btn-sm me-3" v-if="id" @click="disconnectImportConfig(id)"><i class="ti ti-alert-triangle me-2"></i> Disconnect</button>  
  <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
  <button type="submit" class="btn btn-primary">Save</button>
 </div>
</form>
</div>
</div>
</div>
<!-- LEAD IMPORT CONFIG -->

<!-- PAYMENT GATEWAY CONFIG -->
 <div class="modal fade" id="app_store_payment_gateway_config">
 <div class="modal-dialog modal-dialog-centered modal-sm w-100">
 <div class="modal-content">
 <div class="modal-header">
 <h4 class="modal-title">Connect <span class="text-capitalize">{{ platform }}</span></h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
 </button>
 </div>
 <form @submit.prevent="paymentGatewayConfiguration">
 <div class="modal-body pb-0">
  <div class="row">

  <div class="warning-alert mb-2">
  <strong>⚠️ Important:</strong> Please configure this URL <strong>https://algoads.app</strong> in your Razorpay account.
  <a href="javascript:void(0);" class="btn btn-sm btn-outline-info" @click="$copyText(`https://algoads.app`)">Copy URL <i class="ti ti-copy"></i></a>
  <br>
  <a href="https://razorpay.com/docs/payments/dashboard/account-settings/business-website-details/?preferred-country=IN" target="_blank" style="color: #0d6efd; text-decoration: underline;">Click here to see how to do it → </a>
  </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Api Key</label>
      <input type="text" class="form-control" v-model="api_key" />
      <div v-if="errors.api_key" class="text-danger small mt-1">{{ errors.api_key[0] }}</div>
    </div>
    </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Api Secret </label>
      <input type="text" class="form-control" v-model="api_secret" />
      <div v-if="errors.api_secret" class="text-danger small mt-1">{{ errors.api_secret[0] }}</div>
    </div>
    </div>
    
 </div>
 </div>
 <div class="modal-footer">
  <button type="button" class="btn btn-danger btn-sm me-3" v-if="id" @click="disconnectPaymentGatewayConfig(id)"><i class="ti ti-alert-triangle me-2"></i> Disconnect</button>  
  <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
  <button type="submit" class="btn btn-primary">Save</button>
 </div>
</form>
</div>
</div>
</div>
<!-- PAYMENT GATEWAY CONFIG -->

<!-- ACCOUNTING CONFIG -->
 <div class="modal fade" id="app_store_accounting_config">
 <div class="modal-dialog modal-dialog-centered modal-sm w-100">
 <div class="modal-content">
 <div class="modal-header">
 <h4 class="modal-title">Connect <span class="text-capitalize">{{ platform }}</span></h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
 </button>
 </div>
 <form @submit.prevent="accountingConfiguration">
 <div class="modal-body pb-0">
  <div class="row">
 
   <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Client ID</label>
     <input type="text" class="form-control" v-model="client_id" />
     <div v-if="errors.client_id" class="text-danger small mt-1">{{ errors.client_id[0] }}</div>
    </div>
   </div>

   <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Client Secret</label>
     <input type="text" class="form-control" v-model="client_secret" />
     <div v-if="errors.client_secret" class="text-danger small mt-1">{{ errors.client_secret[0] }}</div>
    </div>
   </div>
    
  </div>
 </div>
 <div class="modal-footer">
  <button type="button" class="btn btn-danger btn-sm me-3" v-if="id" @click="disconnectAccountingConfig(id)"><i class="ti ti-alert-triangle me-2"></i> Disconnect</button>  
  <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
  <button type="submit" class="btn btn-primary">Save</button>
 </div>
</form>
</div>
</div>
</div>
<!-- ACCOUNTING CONFIG -->

<!-- COMMUNICATION CONFIG -->
 <div class="modal fade" id="app_store_communication_config">
 <div class="modal-dialog modal-dialog-centered modal-sm w-100">
 <div class="modal-content">
 <div class="modal-header">
 <h4 class="modal-title">Connect <span class="text-capitalize">{{ provider }}</span></h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
 </button>
 </div>
 <form @submit.prevent="communicationConfiguration">
 <div class="modal-body pb-0">
  <div class="row">
 
   <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">API Key</label>
     <input type="text" class="form-control" v-model="api_key" />
     <div v-if="errors.api_key" class="text-danger small mt-1">{{ errors.api_key[0] }}</div>
    </div>
   </div>

   <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Auth Token</label>
     <input type="text" class="form-control" v-model="auth_token" />
     <div v-if="errors.auth_token" class="text-danger small mt-1">{{ errors.auth_token[0] }}</div>
    </div>
   </div>

   <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Sender ID (SMS)</label>
     <input type="text" class="form-control" v-model="sender_id_sms" />
     <div v-if="errors.sender_id_sms" class="text-danger small mt-1">{{ errors.sender_id_sms[0] }}</div>
    </div>
   </div>

   <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Sender ID (WhatsApp)</label>
     <input type="text" class="form-control" v-model="sender_id_whatsapp" />
     <div v-if="errors.sender_id_whatsapp" class="text-danger small mt-1">{{ errors.sender_id_whatsapp[0] }}</div>
    </div>
   </div>

   <div class="col-md-12" v-if="provider === 'prasar_ai'">
    <div class="mb-3">
     <label class="form-label">Username</label>
     <input type="text" class="form-control" v-model="username" />
     <div v-if="errors.username" class="text-danger small mt-1">{{ errors.username[0] }}</div>
    </div>
   </div>

   <div class="col-md-12" v-if="provider === 'prasar_ai'">
    <div class="mb-3">
     <label class="form-label">Secret</label>
     <input type="text" class="form-control" v-model="secret" />
     <div v-if="errors.secret" class="text-danger small mt-1">{{ errors.secret[0] }}</div>
    </div>
   </div>

   <div class="col-md-12" v-if="provider === 'meta'">
    <div class="mb-3">
     <label class="form-label">Business Account ID (Meta WABA)</label>
     <input type="text" class="form-control" v-model="business_account_id" />
     <div v-if="errors.business_account_id" class="text-danger small mt-1">{{ errors.business_account_id[0] }}</div>
    </div>
   </div>
    
  </div>
 </div>
 <div class="modal-footer">
  <button type="button" class="btn btn-danger btn-sm me-3" v-if="id" @click="disconnectCommunicationConfig(id)"><i class="ti ti-alert-triangle me-2"></i> Disconnect</button>  
  <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
  <button type="submit" class="btn btn-primary">Save</button>
 </div>
</form>
</div>
</div>
</div>
<!-- COMMUNICATION CONFIG -->

</template>